import loadable from '@loadable/component';

export const LazyAnnouncement = loadable(() => import(/* webpackChunkName: "content/guest/announcement" */ './Announcement'));
